import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

// Components
import Vehicle from './Vehicle';


// Reducers
import vehicleReducer from './Vehicle/store/vehicleReducer';


// const hasPermission = (permissions, permission) => {
//     return permissions.includes('*') || permissions.includes(permission);
// };

// Routes
export const routes = (basePath, permissions) =>
    <Switch>
        {<Route path={basePath} exact component={Vehicle} />}
    </Switch>


export const reducers = combineReducers({
    vehicles: vehicleReducer
});